import React from "react";

const Socialresponsesectioncontetn = () => {
    return (
        <div id="hs_cos_wrapper_widget_1719384527279" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module" style={{ background: '#fff', justifyContent: 'center', width: '100%', marginTop: '-20px' }}>
            <style>
                {`
          .text-container {
            padding: 0;
          }

          .editor-wrapper {
            margin: 20px 0;
          }

        //   .container {
        //     max-width: 1200px;
        //     margin: 0 auto;
        //     padding: 20px;
        //   }

          .editor-wrapper p {
            font-size: 16px;
            line-height: 1.6;
            color: #333;
          }

          .editor-wrapper strong {
            font-weight: bold;
          }

          .editor-wrapper img {
            max-width: 100%;
            height: auto;
          }

          .editor-wrapper img[src*="box-mosule-img.png"] {
            margin-top: 20px;
          }
        `}
            </style>
            <br></br>
            <h1 style={{ textAlign: 'center' }}><span style={{ color: 'rgb(15 128 155)' }}> Introduction</span></h1>
            <div className="row text-container widget_1719384527279" style={{ width: '100%', justifyContent: "center" }}>

                <div className="editor-wrapper">
                    <div className="container">
                        <p style={{ textAlign: 'center', fontWeight: 'bold' }}>

                            At Envision, we believe that the growth of our community is essential to our success. Our commitment to Corporate Social Responsibility (CSR) spans across Quality Education, Digital Literacy, Skill Development, Women's Empowerment, Community Development, Healthcare, Innovation, and Entrepreneurship.

                        </p>
                        <p style={{ textAlign: 'center', fontWeight: 'bold' }}>

                            In India, our CSR activities are undertaken through the Envision Foundation, directly impacting the communities we operate in. Globally, we collaborate with like-minded organizations to empower local communities and drive positive change.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Socialresponsesectioncontetn;
